import { gql } from 'apollo-angular'

import {
  EDITORIAL_BOARD,
  MAGAZINE_BASIC_FIELDS,
  MAGAZINE_DETAIL_FIELDS,
} from '../../fragments/magazine.fragments'

export const GET_EDITION_BY_ID = gql`
  query getEditionById($id: Int!) {
    Edition(id: $id, select: true) {
      id
      edition_version
      title
      volume
      year
      magazine {
        ...MagazineBasicFields
        ...MagazineDetailFields
        ...EditorialBoard
      }
      slug
      createdAt
      updatedAt
      published_at
      pdf
    }
  }
  ${MAGAZINE_BASIC_FIELDS}
  ${MAGAZINE_DETAIL_FIELDS}
  ${EDITORIAL_BOARD}
`
